import React, { useCallback, useState } from 'react';
import { TextField } from '@mui/material';
import { useSetRecoilState } from 'recoil';
import BeaconFilterRange from '../../../models/BeaconFilterRange';
import BeaconFilterVariant from '../../../models/BeaconFilterVariant';
import stateFilterRange from '../../../state/stateFilterRange';
import stateFilterVariant from '../../../state/stateFilterVariant';
import stateFilterAminoacidChange from '../../../state/stateFilterAminoacidChange';
import Configuration from '../../../config/Configuration';

const patternRangeVirus = new RegExp('^([0-9]+)-([0-9]+)$');
const patternVariantVirus = new RegExp(
  '^([0-9]+)(:| )([ACGT]+)( )?(:|>)( )?([ACGT]+)$'
);
const patternRange = new RegExp('^([A-Za-z0-9_.]+):([0-9]+)-([0-9]+)$');
const patternVariant = new RegExp(
  '^([A-Za-z0-9_.]+):([0-9]+):([ACGT]*):([ACGT]*)$'
);

const patternAminoacidChange = new RegExp('^p.');

const defaultSequence = Configuration.DEFAULT_SEQUENCE_ID;

function QueryVariant() {
  const [setText] = useState('');
  const [error, setError] = useState(false);
  const setFilterRange = useSetRecoilState(stateFilterRange);
  const setFilterVariant = useSetRecoilState(stateFilterVariant);
  const setFilterAminoacidChange = useSetRecoilState(
    stateFilterAminoacidChange
  );

  const helperText = error
    ? 'Incorrect format or exceeded the limit of bases in a range (max 100 bases).  E.g.: 27807 C>T, 21630-21650, p.Ser135Arg.'
    : 'Chromosomal locations are 1-based interbase coordinates. E.g.: 27807 C>T, 21630-21650 (max 100 bases), p.Ser135Arg. ';

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      const value = (event.target.value || '').trim();
      if (0 < value.length) {
        const m = value.match(patternRangeVirus);
        let find = false;
        if (!!m) {
          find = true;
          const sequence = defaultSequence;
          const start = m[1];
          const end = m[2];
          const range: BeaconFilterRange = { sequence, start, end };
          if (end - start > 100) {
            setFilterRange(null);
            setFilterVariant(null);
            setFilterAminoacidChange(null);
            setError(true);
          } else {
            setFilterVariant(null);
            setFilterRange(range);
            setFilterAminoacidChange(null);
            setError(false);
          }
        }

        if (!find) {
          const m = value.match(patternVariantVirus);
          if (!!m) {
            find = true;
            const sequence = defaultSequence;
            const position = m[1];
            const reference = m[3];
            const alternate = m[7];
            const variant: BeaconFilterVariant = {
              sequence,
              position,
              reference,
              alternate,
            };
            setFilterRange(null);
            setFilterVariant(variant);
            setFilterAminoacidChange(null);
            setError(false);
          }
        }

        if (!find) {
          const m = value.match(patternAminoacidChange);
          if (!!m) {
            find = true;
            setFilterRange(null);
            setFilterVariant(null);
            setFilterAminoacidChange(value);
            setError(false);
          }
        }

        if (!find) {
          const m = value.match(patternRange);
          if (!!m) {
            find = true;
            const sequence = m[1];
            const start = m[2];
            const end = m[3];
            const range: BeaconFilterRange = { sequence, start, end };
            if (end - start > 100) {
              setFilterRange(null);
              setFilterVariant(null);
              setFilterAminoacidChange(null);
              setError(true);
            } else {
              setFilterVariant(null);
              setFilterRange(range);
              setFilterAminoacidChange(null);
              setError(false);
            }
          }
        }
        if (!find) {
          const m = value.match(patternVariant);
          if (!!m) {
            const sequence = m[1];
            const position = m[2];
            const reference = m[3];
            const alternate = m[4];
            const variant: BeaconFilterVariant = {
              sequence,
              position,
              reference,
              alternate,
            };
            setFilterRange(null);
            setFilterVariant(variant);
            setError(false);
          } else {
            setFilterRange(null);
            setFilterVariant(null);
            setFilterAminoacidChange(null);
            setError(true);
          }
        }
      } else {
        setFilterRange(null);
        setFilterVariant(null);
        setFilterAminoacidChange(null);
        setError(false);
      }
    },
    [setText]
  );
  return (
    <TextField
      fullWidth
      variant="outlined"
      helperText={helperText}
      onChange={handleChange}
      error={error}
      size="small"
    />
  );
}

export default QueryVariant;
